import dayjs from "dayjs";

/** Synthetic ids must fit Postgres int4 so cache SQL / originStationId never overflow. Unix seconds stay unique and < 2^31 until 2038. */
let nextSyntheticWaypointSeq = dayjs().unix();

const nextMonotonicWaypointNumber = (): number => {
  // +1: unique ids within the same second; unix(): never fall behind clock after idle/reload
  nextSyntheticWaypointSeq = Math.max(
    nextSyntheticWaypointSeq + 1,
    dayjs().unix(),
  );
  return nextSyntheticWaypointSeq;
};

export const generateStationRouteWaypointId = (): number =>
  -nextMonotonicWaypointNumber();

export const generateStationRouteWaypointSecondaryId = (): number =>
  nextMonotonicWaypointNumber();
